import type { FunctionComponent } from "react";
import { Text } from "@smartsuite/react-ui/lib";
import {
  StyledWrapper,
  StyledWrapperHeader,
  StyledHeaderWrapper,
  SectionHeading,
} from "./styles";
import { ConditionalGroupNameInput } from "./components/GroupNameInput";
import { ConditionalGroupIcon } from "../../../../components/ActionGroup/ActionGroupIcon";
import { SelectFindRecords } from "../../Forms/InputForm/RecordsSourceEditor/SelectFindRecords";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../stores/hooks";
import { SelectWebhookOutput } from "./components/SelectWebhookOutput";
import { t } from "i18next";
import { getGroupName } from "../../../../components/ActionGroup/Looping";
import { StyledLabel } from "../../../../components/ActionGroup/styles";
import {
  isLoopingOutputActionId,
  isSingleFindRecordsAction,
} from "../../Forms/InputForm/RecordsSourceEditor/utils";

export const LoopingSection: FunctionComponent = observer(() => {
  const store = useRootStore();
  const looping = store.automations.candidate.looping;
  const sourceReference =
    looping.source?.oneofKind === "outputReference"
      ? looping.source.outputReference.source
      : looping.source?.oneofKind === "recordList"
        ? looping.source.recordList.recordList
        : undefined;
  const sourceAction =
    sourceReference?.oneofKind === "actionReference"
      ? store.automations.candidate.allActions.find(
          (action) =>
            action.actionReference?.instanceId ===
            sourceReference.actionReference.instanceId,
        )
      : undefined;
  const isSingleFindSource = isSingleFindRecordsAction(sourceAction);

  const isValidSource =
    (looping.source?.oneofKind === "outputReference" &&
      (sourceReference?.oneofKind === "triggerReference" ||
        (sourceReference?.oneofKind === "actionReference" &&
          (isLoopingOutputActionId(sourceReference.actionReference?.actionId) ||
            isSingleFindSource)))) ||
    (looping.source?.oneofKind === "recordList" &&
      sourceReference?.oneofKind === "actionReference" &&
      (isLoopingOutputActionId(sourceReference.actionReference?.actionId) ||
        isSingleFindSource));
  // Output descriptions load asynchronously on open; until then the source
  // can't be resolved, so don't show the "no list" label yet (BUG-21925).
  const isSourceSet =
    !store.automations.isAllDynamicDescriptionsLoaded() ||
    store.automations.candidate.looping.getDefaultGroupName().isSourceSet;

  return (
    <StyledWrapper>
      <StyledWrapperHeader>
        <ConditionalGroupIcon />
        <StyledHeaderWrapper>
          <SectionHeading>
            {getGroupName(store.automations.candidate)}
            {!isSourceSet && (
              <StyledLabel className="action-group-name-empty">
                {t("general.action-group-no-list")}
              </StyledLabel>
            )}
          </SectionHeading>
          <Text color="secondary">
            {t("looping.repeact-for-each-description")}
          </Text>
        </StyledHeaderWrapper>
      </StyledWrapperHeader>
      <SelectFindRecords />
      {isValidSource && <SelectWebhookOutput />}
      <ConditionalGroupNameInput
        value={looping.loopName}
        onChangeValue={(value) => looping.setLoopName(value)}
      />
    </StyledWrapper>
  );
});
